/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_CompressInputs */



/**
* | output |
* | --- |
* | "Compress the event text vertically" |
*
* @param {Shortcut_Keys_Desc_CompressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_compress = /** @type {((inputs?: Shortcut_Keys_Desc_CompressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_CompressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compresser le texte de l'evenement verticalement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Den Ereignistext vertikal komprimieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Comprimi verticalmente il testo dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сожмите текст события по вертикали")
	if (locale === "es") return /** @type {LocalizedString} */ ("Comprimir el texto del evento verticalmente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("垂直压缩事件文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストを縦に圧縮する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट को लंबवत रूप से संपीड़ित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Comprima o texto do evento verticalmente.")
	return /** @type {LocalizedString} */ ("Compress the event text vertically")
});